<template>
  <pagefra>
    <div
      class="notice container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('公告标题')">
              <el-input
                v-model="form.title"
                :placeholder="$l('公告标题')"
                style="width: 110px"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('创建人员')">
              <el-input
                v-model="form.creator"
                :placeholder="$l('创建人员')"
                style="width: 110px"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('创建时间')">
              <el-date-picker
                v-model="noticeTimeValues"
                type="datetimerange"
                :range-separator="$l('至')"
                :start-placeholder="$l('创建开始时间')"
                :end-placeholder="$l('创建结束时间')"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              type="primary"
              icon="el-icon-plus"
              round
              @click="showAdd"
              v-show="hasPermission('新增')"
              >{{ $l("新增") }}
            </el-button>
            <el-button
              icon="el-icon-close"
              round
              @click="deleteNotice"
              v-show="hasPermission('删除')"
              >{{ $l("删除") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            @selection-change="selectChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('公告标题')"
              prop="title"
              align="center"
              min-width="200"
            ></el-table-column>
            <el-table-column
              :label="$l('创建人员')"
              prop="creator"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('创建时间')"
              prop="createDate"
              align="center"
              min-width="200"
              sortable
            ></el-table-column>
            <el-table-column
              property="userType"
              :label="$l('公告范围')"
              min-width="120"
              header-align="center"
              align="center"
              :formatter="userTypeFormatter"
            >
            </el-table-column>
            <el-table-column
              :label="$l('微信推送')"
              prop="enablePush"
              align="center"
              min-width="120"
              :formatter="pushFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('开始时间')"
              prop="startDate"
              align="center"
              min-width="200"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('结束时间')"
              prop="endDate"
              align="center"
              min-width="200"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('公告内容')"
              prop="content"
              align="center"
              min-width="200"
            ></el-table-column>
            <el-table-column
              :label="$l('编辑')"
              min-width="180"
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('编辑')"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showEdit(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-edit-outline"
                >
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>

      <el-dialog
        :title="$l(editDialogTitle)"
        :visible.sync="editDialogVisible"
        width="640px"
      >
        <!-- <el-dialog :title="editDialogTitle" visible="true" @closed="closeEditDialog" width="1200px"> -->
        <el-form
          ref="editForm"
          :model="editForm"
          :rules="rules"
          label-width="140px"
          size="medium"
          class="dialog-form"
        >
          <el-form-item :label="$l('公告标题')" prop="title">
            <el-input v-model="editForm.title" :disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item :label="$l('开始时间')" prop="startDate">
            <el-date-picker
              v-model="editForm.startDate"
              type="datetime"
              :placeholder="$l('选择开始时间')"
              :disabled="disabled"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$l('结束时间')" prop="endDate">
            <el-date-picker
              v-model="editForm.endDate"
              type="datetime"
              :placeholder="$l('选择结束时间')"
              :disabled="disabled"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$l('公告范围')">
            <el-select v-model="editForm.userType" :disabled="disabled">
              <el-option :label="$l('日立内部')" value="1"> </el-option>
              <el-option :label="$l('物业人员')" value="2"> </el-option>
              <el-option :label="$l('家用梯客户')" value="3"> </el-option>
              <el-option :label="$l('电梯服务商')" value="4"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$l('启用微信推送')">
            <el-switch
              v-model="editForm.enablePush"
              :disabled="disabled"
            ></el-switch>
          </el-form-item>
          <el-form-item :label="$l('公告内容')" prop="content">
            <el-input
              type="textarea"
              rows="5"
              v-model="editForm.content"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" v-if="!disabled">
          <el-button round @click="editDialogVisible = false"
            >{{ $l("取消") }}
          </el-button>
          <el-button round type="primary" @click="submit"
            >{{ $l("确定") }}
          </el-button>
        </div>
        <div slot="footer" class="dialog-footer" v-else>
          <el-button round @click="editDialogVisible = false"
            >{{ $l("关闭") }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
export default {
  name: "notice",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var validateTitle = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入接收人")));
      } else {
        callback();
      }
    };
    var validateContent = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入公告内容")));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      form: {
        title: "",
        creator: "",
        startDate: "",
        endDate: "",
      },
      editDialogVisible: false,
      editDialogTitle: "",
      editForm: {
        id: null,
        title: null,
        startDate: null,
        endDate: null,
        userType: "1",
        enablePush: 1,
        content: null,
      },
      rules: {
        title: [
          {
            required: true,
            message: this.$l("请输入公告标题"),
            trigger: "blur",
          },
          {
            max: 100,
            message: this.$l("长度不能超过 100 个字符"),
            trigger: "blur",
          },
          { validator: validateTitle, trigger: "blur" },
        ],
        content: [
          {
            required: true,
            message: this.$l("请输入公告内容"),
            trigger: "blur",
          },
          {
            max: 1000,
            message: this.$l("长度不能超过 1000 个字符"),
            trigger: "blur",
          },
          { validator: validateContent, trigger: "blur" },
        ],
        startDate: [
          {
            required: true,
            message: this.$l("请选择开始时间"),
            trigger: "blur",
          },
        ],
        endDate: [
          {
            required: true,
            message: this.$l("请选择结束时间"),
            trigger: "blur",
          },
        ],
      },
      noticeTimeValues: [],
      tableData: [],
      selectedList: [],
      loading: false,
      fullLoading: false,
      disabled: false,
    };
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      if (this.noticeTimeValues && this.noticeTimeValues.length == 2) {
        this.form.startDate = this.$common.formatDateTime(
          this.noticeTimeValues[0]
        );
        this.form.endDate = this.$common.formatDateTime(
          this.noticeTimeValues[1]
        );
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_notice_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    showAdd() {
      this.editDialogTitle = "新建公告";
      this.editDialogVisible = true;
      this.disabled = false;
      this.editForm.id = null;
      this.$nextTick(() => {
        this.$refs.editForm.resetFields();
      });
    },
    showEdit(row) {
      this.disabled = false;
      this.editDialogTitle = "编辑公告";
      this.editDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.editForm.resetFields();
      });
      this.$http
        .get(this.$apiConfig.get_notice_url + row.id)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            let data = result.data;
            for (let key in this.editForm) {
              if (data.hasOwnProperty(key)) {
                if (key == "userType") {
                  this.editForm[key] = data[key] + "";
                } else {
                  this.editForm[key] = data[key];
                }
              }
            }
            this.editForm.startDate = new Date(this.editForm.startDate);
            this.editForm.endDate = new Date(this.editForm.endDate);
            if (this.editForm.startDate.getTime() <= new Date().getTime()) {
              this.disabled = true;
            }
          } else {
            this.message(result.code, result.msg);
            this.editDialogVisible = false;
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    submit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          let startDate = this.editForm.startDate;
          let endDate = this.editForm.endDate;
          if (endDate.getTime() < new Date().getTime()) {
            this.message(1, "结束时间不能小于当前时间");
            return;
          }
          if (startDate.getTime() >= endDate.getTime()) {
            this.message(1, "开始时间不能大于或等于结束时间");
            return;
          }
          this.editForm.startDate = this.$common.formatDateTime(
            this.editForm.startDate
          );
          this.editForm.endDate = this.$common.formatDateTime(
            this.editForm.endDate
          );
          this.$http
            .post(this.$apiConfig.save_notice_url, this.editForm)
            .then((response) => {
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.editDialogVisible = false;
                this.search();
              }
            })
            .catch((error) => {
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteNotice() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要删除的数据");
        return;
      }
      this.confirmAlert(() => {
        let idList = [];
        for (let i = 0; i < len; i++) {
          idList.push(this.selectedList[i].id);
        }
        let formData = new FormData();
        formData.append("idList", idList);
        this.$http
          .post(this.$apiConfig.delete_notice_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.search();
            }
          })
          .catch((error) => {
            this.errorMessage(this.messageType.delete);
            this.$sentry.captureException(error);
          });
      });
    },
    userTypeFormatter(row) {
      if (row.userType == 1) {
        return "日立内部";
      } else if (row.userType == 3) {
        return "家用梯客户";
      } else if (row.userType == 4) {
        return "电梯服务商";
      }
      return "物业人员";
    },
    pushFormatter(row) {
      if (row.enablePush) {
        return "启用";
      }
      return "禁用";
    },
  },
};
</script>
<style lang="scss" scoped>
.notice {
  em {
    color: red;
  }
  /deep/ .el-form-item__error {
    position: relative;
  }
}
</style>
